export function datepickerMinDate() {
        jQuery.datepicker.setDefaults({
            minDate: 0,
        });
}